import React from "react";
import { FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Task } from "./types";

interface TaskSelectorProps {
  apptheme: any;
  filteredTasks: Task[];
  selectedTask: Task | null;
  setSelectedTask: (task: Task | null) => void;
  setMessages: (messages: any[]) => void;
  taskMessagesMap: { [taskName: string]: any[] };
}

const TaskSelector: React.FC<TaskSelectorProps> = ({
  apptheme,
  filteredTasks,
  selectedTask,
  setSelectedTask,
  setMessages,
  taskMessagesMap
}) => {
  return (
    <div className={`z-2 t-0 sticky px-10 pt-6 ${apptheme.name === "dark-theme" ? "bg-[#1d1d1d]" : "bg-[#faf5ff]"} sticky !important top-0 !important`}>
      <p
        className={`font-bold mb-3 ${apptheme.name === "dark-theme" ? "text-white" : "text-black"}`}
        style={{ textTransform: "none" }}
      >
        SEARCH AGENT SUITE
      </p>
      <FormControl className={`${apptheme.name === "dark-theme" ? "text-white" : "text-black"}`} component="fieldset">
        <RadioGroup
          row
          value={selectedTask?.name || ""}
          onChange={e => {
            const task = filteredTasks.find((t: Task) => t.name === e.target.value);
            setSelectedTask(task || null);
            setMessages(task ? (taskMessagesMap[task.name] || []) : []);
          }}
        >
          {filteredTasks.map((task: Task) => (
            <FormControlLabel
              key={task.name}
              value={task.name}
              control={
                <Radio
                  sx={{
                    color: "#a100ff",
                    "&.Mui-checked": { color: "#a100ff" }
                  }}
                />
              }
              label={task.name.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}
              sx={{
                marginRight: 4,
                ".MuiFormControlLabel-label": {
                  fontWeight: 500,
                  fontSize: "0.75rem",
                  letterSpacing: "0.02em"
                }
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <hr className="mt-4 border-t-2 border-gray-400" />
    </div>
  );
};

export default React.memo(TaskSelector);